<template>
    <div v-if="initDone" class="column is-four-fifths">
        <p class="is-size-5">{{ translate("notification_center.calculated_cost_is") }}</p>
        <p class="mt-3 has-text-centered is-size-3" v-if="numberOfReceivers > 0">
            {{ translate("notification_center.receivers", false, [numberOfReceivers]) }} × {{ formattedPriceForType }} =
            <span class="has-text-primary">{{ formattedTotalPrice }}</span>
        </p>
        <p class="mt-3" v-else>
            <Notification class="is-danger has-text-centered">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>{{ translate("notification_center.choose_type_first") }}</span>
            </Notification>
        </p>
        <p class="mt-6">
            <span class="has-text-weight-bold is-size-5">
                {{ translate("notification_center.why_estimated_cost") }}
            </span>
        </p>
        <p class="mt-2">{{ translate("notification_center.estimated_cost_explain1") }}</p>
        <p class="mt-2">{{ translate("notification_center.estimated_cost_explain2") }}</p>
    </div>
    <div v-else class="column is-four-fifths">
        <div class="columns is-centered">
            <LoadingSpinner2 class="has-added-margin" />
        </div>
    </div>
</template>

<script>
    import apiMixin from "../../Api/apiMixin";
    import { mapState } from "vuex";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2";
    import translatorMixin from "../../Common/translatorMixin";
    import errorHandlerMixin from "../../Common/errorHandlerMixin";
    import Notification from "../../Common/Notification";

    export default {
        name: "cost-calculation-step",
        components: { Notification, LoadingSpinner2 },
        mixins: [apiMixin, translatorMixin, errorHandlerMixin],
        data() {
            return {
                initDone: false,
            };
        },
        computed: {
            ...mapState("filteringReceivers", ["selectedCountries", "paymentStatus"]),
            ...mapState("choosingSourceEvents", ["selectedEvents"]),
            ...mapState("typeOfNotification", ["mainType"]),

            ...mapState("costCalculation", ["numberOfReceivers", "formattedPriceForType", "formattedTotalPrice"]),
        },
        mounted() {
            return this.$store
                .dispatch("costCalculation/calculateCost")
                .catch(this.handleError)
                .finally(() => {
                    this.initDone = true;
                });
        },
    };
</script>

<style scoped></style>
